import React from 'react';
import clsx from 'clsx';

import FilterItem from './FilterItem';

import scss from './FilterSection.module.scss';

function FilterSection({ filters, selectedFilters, onSelect }) {
  const { groupName, title, options, placeholder, fullWidth } = filters;

  const handleSelect = (option) => {
    onSelect({ groupName, option });
  };

  const placeholderOption = {
    label: placeholder,
    value: null,
  };

  return (
    <div className={clsx(scss.filterSection, fullWidth && scss.fullWidth)}>
      <h4 className={scss.title}>{title}</h4>
      <div className={scss.options}>
        {placeholder ? (
          <FilterItem
            option={placeholderOption}
            isChecked={Boolean(!selectedFilters?.[groupName]?.length)}
            onSelect={() => handleSelect(placeholderOption)}
          />
        ) : null}
        {options.map((option) => (
          <FilterItem
            key={option.value}
            option={option}
            isChecked={Boolean(selectedFilters?.[groupName]?.some((item) => item.value === option.value))}
            onSelect={handleSelect}
          />
        ))}
      </div>
    </div>
  );
}

export default FilterSection;
